import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, FileText, Briefcase, Settings, LogOut, Home, HelpCircle } from 'lucide-react';
import { LogoFull } from './Logo';

const AdminLayout = ({ children, activeTab }) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/admin' },
    { id: 'applications', label: 'Applications', icon: FileText, path: '/admin/applications' },
    { id: 'advisors', label: 'Advisors', icon: Briefcase, path: '/admin/advisors' },
    { id: 'questions', label: 'Questions', icon: HelpCircle, path: '/admin/questions' },
    { id: 'settings', label: 'Settings', icon: Settings, path: '/admin/settings' },
  ];

  const currentTab = activeTab || navItems.find(item => location.pathname === item.path)?.id || 'dashboard';

  return (
    <div className="min-h-screen bg-bg-secondary">
      <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-border-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-3">
              <LogoFull size={30} />
              <span style={{
                background: '#004D35',
                color: '#ffffff',
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '0.08em',
                padding: '3px 10px',
                borderRadius: 9999,
                textTransform: 'uppercase',
              }}>Admin</span>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/')}
                className="flex items-center space-x-1 text-sm text-text-secondary hover:text-primary transition-colors"
              >
                <Home className="w-4 h-4" />
                <span>View Site</span>
              </button>
              <span className="text-sm text-text-muted">{user?.email}</span>
              <button
                onClick={signOut}
                className="flex items-center space-x-1 text-sm text-text-secondary hover:text-primary transition-colors"
              >
                <LogOut className="w-4 h-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <nav className="bg-white border-b border-border-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-1 overflow-x-auto">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentTab === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => navigate(item.path)}
                  className={`flex items-center space-x-2 px-4 py-2 my-2 text-sm font-medium transition-all rounded-full whitespace-nowrap ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-text-secondary hover:text-primary hover:bg-bg-secondary'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
